(function () {
    "use strict";

    angular.module('app').filter("kboNumber", FilterFactory);

    FilterFactory.$inject = ["textValidators"];
    function FilterFactory(textValidators) {
        return function (cbeNumber) {
            if (textValidators.IsValidKboNumber(cbeNumber)) {
                const parts = [
                    cbeNumber.substring(0, 4),
                    cbeNumber.substring(4, 7),
                    cbeNumber.substring(7, 10),
                ];
                return parts.join(".");
            }
            else if (textValidators.isValidBranchNumber(cbeNumber)) {
                const parts = [
                    cbeNumber.substring(0, 1),
                    cbeNumber.substring(1, 4),
                    cbeNumber.substring(4, 7),
                    cbeNumber.substring(7, 10),
                ];
                return parts.join(".");
            }

            return cbeNumber;
        };
    }    
})();